<template>
  <form @submit.prevent="save">
    <v-container fluid>
      <v-card-text>
        <v-text-field
          v-model="form.name"
          label="Name"
          append-icon="mdi-account_circle"
          outlined
          class="form-control"
          type="text"
          name="name"
          :class="{ 'is-invalid': form.errors.name }"
          :error="form.errors.name"
          :error-messages="form.errors.name"
        />
        <v-text-field
          v-model="form.email"
          label="Email"
          append-icon="mdi-email"
          outlined
          class="form-control"
          type="email"
          name="email"
          autocomplete="username"
          :class="{ 'is-invalid': form.errors.email }"
          :error="form.errors.email"
          :error-messages="form.errors.email"
        />
        <v-text-field
          v-model="form.password"
          label="Password"
          outlined
          class="form-control"
          name="password"
          autocomplete="new-password"
          :class="{ 'is-invalid': form.errors.password }"
          :error="form.errors.password"
          :error-messages="form.errors.password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
        />
        <v-text-field
          v-model="form.password_confirmation"
          label="Password Confirmation"
          outlined
          class="form-control"
          name="password_confirmation"
          autocomplete="new-password"
          :class="{ 'is-invalid': form.errors.password_confirmation }"
          :error="form.errors.password_confirmation"
          :error-messages="form.errors.password_confirmation"
          :append-icon="showConfirmationPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showConfirmationPassword ? 'text' : 'password'"
          @click:append="showConfirmationPassword = !showConfirmationPassword"
        />
      </v-card-text>
      <v-card-actions>
        <v-checkbox
          v-model="form.terms"
          label="Agree to terms"
          value="true"
          :class="{ 'is-invalid': form.errors.terms }"
          :error="form.errors.terms"
          :error-messages="form.errors.terms"
          color="#033"
        />
        <v-spacer />
        <v-btn
          depressed
          :loading="loading"
          color="primary"
          type="submit"
        >
          Create Account
        </v-btn>
      </v-card-actions>
    </v-container>
  </form>
</template>

<script>
import Layout from '@/Layouts/Basic'

export default {
   metaInfo: { title: 'Login' },
   components: {
      //
   },
   layout: (h, page) => h(Layout, [page]),
   data () {
      return {
         loading: false,
         showPassword: false,
         showConfirmationPassword: false,
         form: this.$inertia.form({
            email: null,
            password: null,
            password_confirmation: null,
            terms: null
         }),
      }
   },
   methods: {
      save () {
         this.loading = true
         this.$inertia.post(this.route('register'), {
            name: this.form.name,
            email: this.form.email,
            password: this.form.password,
            password_confirmation: this.form.password_confirmation,
            terms: this.form.terms
         }).then(() => this.loading = false)
      },
   },
}
</script>
